import { render, staticRenderFns } from "./UpcomingRenewals.vue?vue&type=template&id=61db19c1&scoped=true"
import script from "./UpcomingRenewals.vue?vue&type=script&lang=js"
export * from "./UpcomingRenewals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61db19c1",
  null
  
)

export default component.exports